import request from '@/utils/service'

// 提现审核
export function listApi(data) {
  return request({
    url: '/walletWithdraw/list',
    method: 'get',
    params: data
  })
}

export function auditApi(data) {
  return request({
    url: '/walletWithdraw/audit',
    method: 'post',
    data
  })
}

// 用户提现
export function userWithdrawalListApi(data) {
  return request({
    url: '/userWithdraw/list',
    method: 'post',
    params: data
  })
}
// 用户提现审核
export function userWithdrawAudtitApi(data) {
  return request({
    url: '/userWithdraw/userWithdrawAudtit',
    method: 'post',
    data,
    notUseQstring: true
  })
}

// 用户提现异常修复
export function userWithdrawRepairApi(data) {
  return request({
    url: '/userWithdraw/repair',
    method: 'post',
    data,
    notUseQstring: true
  })
}


// 套餐卡退款审核-------
// 套餐卡审核列表
export function monthCardOrderListApi(data) {
  return request({
    url: '/monthCardOrder/list',
    method: 'post',
    params: data
  })
}
// 套餐卡审核 + 退款
export function monthCardOrderAudtitApi(data) {
  return request({
    url: '/monthCardOrder/audit',
    method: 'post',
    data,
    notUseQstring: true
  })
}
//套餐卡审核 + 批量退款
export function monthCardOrderBatchAudit(data) {
  return request({
    url: '/monthCardOrder/batchAudit',
    method: 'post',
    data,
    notUseQstring: true
  })
}


// 充电订单退款审核-------
// 充电订单审核列表
export function chargeOrderRefundListApi(data) {
  return request({
    url: '/chargePieOrderRefundRecord/list',
    method: 'post',
    params: data
  })
}

// 充电订单审核 + 退款
export function chargeOrderAudtitApi(data) {
  return request({
    url: '/chargePieOrderRefundRecord/audit',
    method: 'post',
    data,
    notUseQstring: true
  })
}
//充电订单审核 + 批量退款
export function chargeOrderBatchAuditApi(data) {
  return request({
    url: '/chargePieOrderRefundRecord/batchAudit',
    method: 'post',
    data,
    notUseQstring: true
  })
}


// 超时占用订单退款审核-------
// 超时占用订单审核列表
export function  timeoutOrderRefundListApi(data) {
  return request({
    url: '/TimeoutOccupancyOrderRefundRecord/list',
    method: 'post',
    params: data
  })
}
// 超时占用订单审核 + 退款
export function timeoutOrderRefundApi(data) {
  return request({
    url: '/TimeoutOccupancyOrderRefundRecord/auditRecord',
    method: 'post',
    data,
    notUseQstring: true
  })
}
//超时占用订单审核 + 批量退款
export function timeoutOrderBatchRefundApi(data) {
  return request({
    url: '/TimeoutOccupancyOrderRefundRecord/batchAuditRecord',
    method: 'post',
    data,
    notUseQstring: true
  })
}


